import script from "./TranslateVideoCaptionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslateVideoCaptionModal.vue?vue&type=script&setup=true&lang=js"

import "./TranslateVideoCaptionModal.vue?vue&type=style&index=0&id=0e340ea2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e340ea2"]])

export default __exports__